module.exports = __webpack_public_path__ + "static/media/Whofolio_on_mobile_2.a6d989b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/images/Whofolio_on_mobile_2.png
// module id = 163
// module chunks = 0